import { Router } from '@angular/router';

import { Component, OnInit } from '@angular/core';
import { PartnerOnboardingDto } from 'src/app/model/partner-onboarding-dto';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { PartnerOnboardingMasterDto } from 'src/app/model/partner-onboarding-master-dto';
import { AppSettingService } from 'src/app/services/app-setting.service';

@Component({
  selector: 'app-partner-on-board',
  templateUrl: './partner-on-board.component.html',
  styleUrls: ['./partner-on-board.component.css']
})
export class PartnerOnBoardComponent implements OnInit {

  isLessOrMoreDate;
  showMessage;
  loading;

  partnerOnboardingList: PartnerOnboardingDto[];
  partnerOnboardingInitallList: PartnerOnboardingDto[];
  partnerTypeModal;
  partnerOnboardingFilterList: PartnerOnboardingDto[];
  disBlk:boolean=false;
  disBlk1:boolean=false;
  disBlk2:boolean=false;
  partNumb ="";
  partName ="";
  sapPayerName="";

searchIconActive=false;
  searchIconActive1 = false;
  searchIconActive2 = false;
  partnerFilterList: PartnerOnboardingDto[];
  partnerTypeList: PartnerOnboardingMasterDto[];

  mlrPaginationcount = 25;
  mlrPaginationConfiguration;
  partnerOnboarindResetModalPopup;

  constructor(private httpclientService: HttpclientService, private router: Router, public appSettingService: AppSettingService ) {
   
   }

  ngOnInit() {
    this.partnerTypeModal = '-1';
    this.mlrPaginationConfiguration = { currentPage: '25 per page', itemsPerPage: '25' };
    this.getPartnerTypeList();
    this.getPartnerOnboardingList();
  }


  pressingCancel() {
    this.partnerOnboarindResetModalPopup =  false;
  }

partnerOnboardingReset() {
this.showMessage = '';
this.partNumb = '';
this.partnerTypeModal = '-1';
this.getPartnerOnboardingList();
this.partnerOnboarindResetModalPopup =  false;

}



partnerOnboardingResetPopUp() {
  this.partnerOnboarindResetModalPopup =  true;

}




/****************************************************** Pagination Start ***************************************************/
mlrOnChangePagination(value) {

  this.mlrPaginationConfiguration.itemsPerPage = value;
  this.mlrPaginationcount = value;
}

mlrPageOnChanged(event) {
  this.mlrPaginationConfiguration.currentPage = event;
}
/****************************************************** Pagination End ***************************************************/


  getPartnerTypeList() {
    this.loading = true;
    this.httpclientService.getPartnerTypeList().subscribe(
    data => {
      this.partnerTypeList = data;
      this.loading = false;
    }
  );
  }

  getPartnerOnboardingList() {
  this.loading = true;
  this.partnerOnboardingList = [];
  this.httpclientService.getPartnerOnboardingList().subscribe(
  data => {
    this.partnerOnboardingList = data;
    this.partnerOnboardingInitallList = data;
    // this.partnerTypeList = Array.from(this.partnerOnboardingInitallList.reduce((m, t) => m.set(t.partnerType, t), new Map()).values());

    this.loading = false;
  }
);
}
// .......................... Search Block Start ...............................//

selectePartnerType() {
console.log('partnerTypeModal..'+this.partnerTypeModal);
this.showMessage = '';
if (this.partnerTypeModal !== '-1') {
  
  this.partnerFilterList = this.partnerOnboardingInitallList.filter(book => book.partnerType === this.partnerTypeModal);

  if (this.partNumb.length > 0) {
    console.log('this.partNumb..'+this.partNumb);
    this.partnerOnboardingFilterList = this.partnerFilterList.
    filter(book => book.partnerNumber.toLowerCase().startsWith(this.partNumb.toLowerCase()));

    console.log('this.partnerOnboardingFilterList..'+this.partnerOnboardingFilterList.length);
    if (this.partnerOnboardingFilterList.length === 0) {
      this.partnerOnboardingFilterList = this.partnerFilterList.
      filter(book => book.partnerName.toLowerCase().startsWith(this.partNumb.toLowerCase()));
    }
    if (this.partnerOnboardingFilterList.length === 0) {
      this.partnerOnboardingInitallList.forEach(pdto => {
        if (pdto.sapPayerNumbers === null){

        } else {
      if (pdto.sapPayerNumbers.toLowerCase().startsWith(this.partNumb.toLowerCase())) {
        this.partnerOnboardingFilterList.push(pdto);
        }

        }
      });
    }
    this.partnerOnboardingList = this.partnerOnboardingFilterList;

    if (this.partnerOnboardingFilterList.length === 0) {
      this.showMessage = 'No Record Found';
    
    }
  } else {
    this.partnerOnboardingList = this.partnerFilterList;
  }
} else {
  this.checkPartnerNumber();
}

}

// .......................... Search Block End ...............................//
goToCreatePartner() {
this.router.navigate(['create partner on boarding']);
}


checkPartnerNumber(){
  console.log('.this.partNumb...'+this.partNumb+'....'+this.partNumb.length);
  this.showMessage = '';
  if (this.partNumb.length > 0) {
    this.partnerOnboardingFilterList = this.partnerOnboardingInitallList.filter
    (book => book.partnerNumber.toLowerCase().startsWith(this.partNumb.toLowerCase()));
    if(this.partnerOnboardingFilterList.length === 0){
      this.partnerOnboardingFilterList = this.partnerOnboardingInitallList.filter
      (book => book.partnerName.toLowerCase().startsWith(this.partNumb.toLowerCase()));
    }
    if(this.partnerOnboardingFilterList.length === 0){
      this.partnerOnboardingInitallList.forEach(pdto => {
        if (pdto.sapPayerNumbers === null){

        } else {
      if (pdto.sapPayerNumbers.toLowerCase().startsWith(this.partNumb.toLowerCase())) {
        this.partnerOnboardingFilterList.push(pdto);
        }

        }
      });

    }
    if (this.partnerTypeModal !== '-1') {
      this.partnerOnboardingFilterList = this.partnerOnboardingFilterList.filter
      (book => book.partnerType  === this.partnerTypeModal);
    }
    if(this.partnerOnboardingFilterList.length === 0){
      this.showMessage = 'No Record Found';

    }
    this.partnerOnboardingList = this.partnerOnboardingFilterList;
  } else {
    if (this.partnerTypeModal === '-1') {
    this.partnerOnboardingList = this.partnerOnboardingInitallList;
    }
    // this.showMessage = 'Please Enter Search Input';

  }

}



// checkPartnerName(){
//   if (this.partName !== ' ') {
//     this.partnerOnboardingFilterList = this.partnerOnboardingInitallList.filter
//     (book => book.partnerName.toLowerCase().startsWith(this.partNumb.toLowerCase()));
//     this.partnerOnboardingList = this.partnerOnboardingFilterList;
//   } else {
//     this.partnerOnboardingList = this.partnerOnboardingInitallList;
//   }

// }


// checkSapPayeNumber(){
//   if (this.sapPayerName !== ' ') {
//     this.partnerOnboardingFilterList = this.partnerOnboardingInitallList.filter(book => book.sapPayerNumbers === this.sapPayerName);
//     this.partnerOnboardingList = this.partnerOnboardingFilterList;
//   } else {
//     this.partnerOnboardingList = this.partnerOnboardingInitallList;
//   }

// }

chkVal(){
  this.disBlk = true;
  this.searchIconActive = true;
  this.disBlk1 = false;
  this.disBlk2 = false;
 }
 blurOut(){
   this.searchIconActive = false;
 }
 valDel(){
  this.partNumb = ''
  this.showMessage = '';
  this.disBlk=false;
  this.searchIconActive=false
  if (this.partnerTypeModal !== '-1') {
  this.partnerFilterList = this.partnerOnboardingInitallList.filter(book => book.partnerType === this.partnerTypeModal);
  this.partnerOnboardingList = this.partnerFilterList;
  } else{
    this.partnerOnboardingList = this.partnerOnboardingInitallList;
  }
 }


 chkNameVal(){
   this.disBlk1=true;
  this.searchIconActive1=true
  this.disBlk=false;
  this.disBlk2=false;

 }
 blurNameOut(){
   this.searchIconActive1=false;
 }
 valNameDel(){
   this.partName = ''
   this.disBlk1=false;
  this.searchIconActive1=false
 }


 chkSapVal(){
   this.disBlk2=true;
   this.searchIconActive2=true
   this.disBlk=false;
   this.disBlk1=false;
 }
 blurSapOut(){
   this.searchIconActive2=true
 }
 valSapDel(){
  this.partnerOnboardingList = this.partnerOnboardingInitallList;

   this.sapPayerName = ''
   this.disBlk2=false;
  this.searchIconActive2=false
 }



}
